import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Sofía G.',
  city: 'Monterrey',
  time: 'hace 3 minutos'
}, {
  name: 'Daniela R.',
  city: 'CDMX',
  time: 'hace 7 minutos'
}, {
  name: 'Patricia M.',
  city: 'Guadalajara',
  time: 'hace 12 minutos'
}, {
  name: 'Claudia L.',
  city: 'Puebla',
  time: 'hace 18 minutos'
}, {
  name: 'Verónica S.',
  city: 'Querétaro',
  time: 'hace 25 minutos'
}, {
  name: 'Gabriela T.',
  city: 'Mérida',
  time: 'hace 32 minutos'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialTimer = setTimeout(() => {
      if (!isDismissed) setIsVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    // Hide after 5 seconds, then show next after 15 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
    }, 20000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [isVisible, currentIndex, isDismissed]);
  const buyer = buyers[currentIndex];
  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  return <AnimatePresence data-id="element-221">
      {isVisible && !isDismissed && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 200
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)] border border-sage/10 p-3 pr-10 flex items-center gap-3 max-w-[340px]" data-id="element-222">
          {/* Product image */}
          <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 bg-cream" data-id="element-223">
            <img src="https://cdn.magicpatterns.com/uploads/2dDCDgq8yAYwtpqwYtng8M/mockup1.png" alt="Plan Antiinflamatorio +40" className="w-full h-full object-cover" data-id="element-224" />
          </div>

          {/* Info */}
          <div className="flex flex-col min-w-0" data-id="element-225">
            <p className="text-olive font-bold text-sm truncate" data-id="element-226">
              {buyer.name} — {buyer.city}
            </p>
            <p className="text-warm-gray text-xs leading-snug" data-id="element-227">
              Compró{' '}
              <span className="font-semibold text-olive" data-id="element-228">
                Plan Antiinflamatorio +40
              </span>
            </p>
            <div className="flex items-center gap-2 mt-1" data-id="element-229">
              <span className="text-sage font-bold text-sm" data-id="element-230">$114 MXN</span>
              <span className="text-warm-gray/60 text-[10px]" data-id="element-231">
                {buyer.time}
              </span>
            </div>
          </div>

          {/* Close button */}
          <button onClick={handleDismiss} className="absolute top-2 right-2 text-warm-gray/40 hover:text-warm-gray transition-colors" aria-label="Cerrar notificación" data-id="element-232">
            <XIcon className="w-4 h-4" data-id="element-233" />
          </button>

          {/* Verified badge */}
          <div className="absolute -top-2 -left-1" data-id="element-234">
            <span className="bg-sage text-white text-[9px] font-bold px-2 py-0.5 rounded-full shadow-sm" data-id="element-235">
              ✓ Verificado
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}